var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('edit',{attrs:{"is-system-admin":true,"redirect-route":"admin-announcements-list","resource":"global-ActivityController"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }